module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_troms_og_finnmark_neg.14d1a8b7.svg";